import { render, staticRenderFns } from "./AppDownloadPhotoPlus.vue?vue&type=template&id=21b4396e&scoped=true&"
import script from "./AppDownloadPhotoPlus.vue?vue&type=script&lang=js&"
export * from "./AppDownloadPhotoPlus.vue?vue&type=script&lang=js&"
import style0 from "./AppDownloadPhotoPlus.vue?vue&type=style&index=0&id=21b4396e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b4396e",
  null
  
)

export default component.exports